const Constants = {
  endpointBasePath: "/case-law-documents",
  caseLawDocumentTypePath: "/case-law-document-types",
  organisationCaseLawDocumentTypePath: "/case-law-document-types/organisation",
  organisationsPath: "/organisations",
  courtCasesPath: "/court-case",
  organisationsCaseLawDocumentTypePath: "/organisations/case-law-document-type",
  courtCaseLawDocumentPath: "/case-law-documents/court-cases",
  attachmentPath: "/attachments",
  indexesCategoryPath: "/indexes/category",
  indexCategoriesPath: "/index-categories",
  attachmentTypePath: "/attachment-types",
  registryInstitutionPath: "/organisations/registry",
  legalViewTypesPath: "/legal-view-types",
  caseDecisionTypesPath: "/case-decision-types",
  indexes: "/indexes"
};
export default Constants;
